var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "pb-4" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h2", [
          _vm._v(_vm._s(_vm.$t("message.notification_settings.title")))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-4" }, [
      _c("div", { staticClass: "col-8" }, [_vm._v("\n       \n    ")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2 text-center" }, [
        _c("label", [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("message.notification_settings.email")) +
              "\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2 text-center" }, [
        _c("label", [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("message.notification_settings.sms")) +
              "\n      "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-8" }, [
        _c("label", [
          _vm._v(_vm._s(_vm.$t("message.notification_settings.reminders")))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2" }, [_vm._v(" ")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2" }, [_vm._v(" ")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-8" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("message.notification_settings.reminders_detail")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2 text-center" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userSetting.notification_reminders_email,
              expression: "userSetting.notification_reminders_email"
            }
          ],
          attrs: { type: "checkbox", "true-value": 1, "false-value": 0 },
          domProps: {
            checked: Array.isArray(_vm.userSetting.notification_reminders_email)
              ? _vm._i(_vm.userSetting.notification_reminders_email, null) > -1
              : _vm._q(_vm.userSetting.notification_reminders_email, 1)
          },
          on: {
            change: [
              function($event) {
                var $$a = _vm.userSetting.notification_reminders_email,
                  $$el = $event.target,
                  $$c = $$el.checked ? 1 : 0
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(
                        _vm.userSetting,
                        "notification_reminders_email",
                        $$a.concat([$$v])
                      )
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.userSetting,
                        "notification_reminders_email",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.userSetting, "notification_reminders_email", $$c)
                }
              },
              _vm.updateUserSetting
            ]
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2 text-center" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userSetting.notification_reminders_sms,
              expression: "userSetting.notification_reminders_sms"
            }
          ],
          attrs: { type: "checkbox", "true-value": 1, "false-value": 0 },
          domProps: {
            checked: Array.isArray(_vm.userSetting.notification_reminders_sms)
              ? _vm._i(_vm.userSetting.notification_reminders_sms, null) > -1
              : _vm._q(_vm.userSetting.notification_reminders_sms, 1)
          },
          on: {
            change: [
              function($event) {
                var $$a = _vm.userSetting.notification_reminders_sms,
                  $$el = $event.target,
                  $$c = $$el.checked ? 1 : 0
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(
                        _vm.userSetting,
                        "notification_reminders_sms",
                        $$a.concat([$$v])
                      )
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.userSetting,
                        "notification_reminders_sms",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.userSetting, "notification_reminders_sms", $$c)
                }
              },
              _vm.updateUserSetting
            ]
          }
        })
      ])
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-8" }, [
        _c("label", [
          _vm._v(_vm._s(_vm.$t("message.notification_settings.messages")))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2" }, [_vm._v(" ")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2" }, [_vm._v(" ")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-8" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("message.notification_settings.messages_detail")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2 text-center" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userSetting.notification_messages_email,
              expression: "userSetting.notification_messages_email"
            }
          ],
          attrs: { type: "checkbox", "true-value": 1, "false-value": 0 },
          domProps: {
            checked: Array.isArray(_vm.userSetting.notification_messages_email)
              ? _vm._i(_vm.userSetting.notification_messages_email, null) > -1
              : _vm._q(_vm.userSetting.notification_messages_email, 1)
          },
          on: {
            change: [
              function($event) {
                var $$a = _vm.userSetting.notification_messages_email,
                  $$el = $event.target,
                  $$c = $$el.checked ? 1 : 0
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(
                        _vm.userSetting,
                        "notification_messages_email",
                        $$a.concat([$$v])
                      )
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.userSetting,
                        "notification_messages_email",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.userSetting, "notification_messages_email", $$c)
                }
              },
              _vm.updateUserSetting
            ]
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2 text-center" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userSetting.notification_messages_sms,
              expression: "userSetting.notification_messages_sms"
            }
          ],
          attrs: { type: "checkbox", "true-value": 1, "false-value": 0 },
          domProps: {
            checked: Array.isArray(_vm.userSetting.notification_messages_sms)
              ? _vm._i(_vm.userSetting.notification_messages_sms, null) > -1
              : _vm._q(_vm.userSetting.notification_messages_sms, 1)
          },
          on: {
            change: [
              function($event) {
                var $$a = _vm.userSetting.notification_messages_sms,
                  $$el = $event.target,
                  $$c = $$el.checked ? 1 : 0
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(
                        _vm.userSetting,
                        "notification_messages_sms",
                        $$a.concat([$$v])
                      )
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.userSetting,
                        "notification_messages_sms",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.userSetting, "notification_messages_sms", $$c)
                }
              },
              _vm.updateUserSetting
            ]
          }
        })
      ])
    ]),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-8" }, [
        _c("label", [
          _vm._v(
            _vm._s(_vm.$t("message.notification_settings.news_promotions"))
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2" }, [_vm._v(" ")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2" }, [_vm._v(" ")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-8" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.$t("message.notification_settings.news_promotions_detail")
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2 text-center" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userSetting.notification_promotions_email,
              expression: "userSetting.notification_promotions_email"
            }
          ],
          attrs: { type: "checkbox", "true-value": 1, "false-value": 0 },
          domProps: {
            checked: Array.isArray(
              _vm.userSetting.notification_promotions_email
            )
              ? _vm._i(_vm.userSetting.notification_promotions_email, null) > -1
              : _vm._q(_vm.userSetting.notification_promotions_email, 1)
          },
          on: {
            change: [
              function($event) {
                var $$a = _vm.userSetting.notification_promotions_email,
                  $$el = $event.target,
                  $$c = $$el.checked ? 1 : 0
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(
                        _vm.userSetting,
                        "notification_promotions_email",
                        $$a.concat([$$v])
                      )
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.userSetting,
                        "notification_promotions_email",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(
                    _vm.userSetting,
                    "notification_promotions_email",
                    $$c
                  )
                }
              },
              _vm.updateUserSetting
            ]
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2 text-center" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userSetting.notification_promotions_sms,
              expression: "userSetting.notification_promotions_sms"
            }
          ],
          attrs: { type: "checkbox", "true-value": 1, "false-value": 0 },
          domProps: {
            checked: Array.isArray(_vm.userSetting.notification_promotions_sms)
              ? _vm._i(_vm.userSetting.notification_promotions_sms, null) > -1
              : _vm._q(_vm.userSetting.notification_promotions_sms, 1)
          },
          on: {
            change: [
              function($event) {
                var $$a = _vm.userSetting.notification_promotions_sms,
                  $$el = $event.target,
                  $$c = $$el.checked ? 1 : 0
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(
                        _vm.userSetting,
                        "notification_promotions_sms",
                        $$a.concat([$$v])
                      )
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.userSetting,
                        "notification_promotions_sms",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.userSetting, "notification_promotions_sms", $$c)
                }
              },
              _vm.updateUserSetting
            ]
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_c("hr")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_c("hr")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa42b522", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa42b522","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Notification.vue
// module id = 1930
// module chunks = 0